import blobStorageRepository from "../shared/blobStorage/blobStorageRepository";
import experimentRepository from "./experiment/experimentRepository";
export default {
    experiments: experimentRepository,
    blobStorage: blobStorageRepository
};
